document.addEventListener('DOMContentLoaded', () => {
  const checkoutInquiryPopup = document.querySelector('[data-checkout-inquiry-popup]');
  const checkoutInquiryPopupOverlay = document.querySelector('[data-popup-overlay="checkout-inquiry"]');
  const checkoutInquiryPopupClose = checkoutInquiryPopupOverlay.querySelector('[data-action-close]');
  const form = checkoutInquiryPopupOverlay.querySelector('[data-checkout-inquiry-popup-form]');
  const button = checkoutInquiryPopupOverlay.querySelector('[data-checkout-inquiry-popup-button]');

  checkoutInquiryPopup.addEventListener('click', () => {
    document.querySelector('cart-drawer').classList.remove('active');
    checkoutInquiryPopupOverlay.style.display = 'flex';
    checkoutInquiryPopupOverlay.classList.add('popup-active');
  });

  checkoutInquiryPopupClose.addEventListener('click', () => {
    closePopup();
  });

  checkoutInquiryPopupOverlay.addEventListener('click', (e) => {
    if (e.target === checkoutInquiryPopupOverlay) {
      closePopup();
    }
  });

  function closePopup() {
    checkoutInquiryPopupOverlay.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
    checkoutInquiryPopupOverlay.classList.remove('popup-active');
    checkoutInquiryPopup.classList.remove('popup-active');
    form.classList.remove('contact-sponser-form--parent-active');
    button.classList.remove('contact-sponser-form__button--active');
  }
});
